<template>
  <div class="member-select-list">
    <div class="title-info">
      <div class="h1">{{ pageTitle }}</div>
    </div>
    <div class="list-section">
      <van-checkbox-group v-model="selectedIds">
        <div
          v-for="(item, index) in list"
          :key="item.id || index"
          class="list-item"
          @click="toggleSelect(item)"
        >
          <div class="avatar">
            <img
              :src="imageView(item.avatar || 'Fr-N88b2bLOV_U38rSHcFChbRtU4')"
              alt=""
            />
          </div>
          <div class="info">
            <template v-if="type === 'player'">
              <div class="info-name">{{ item.playerName || '-' }}</div>
              <div class="info-row" :class="{ invalid: isAgeIneligible(item) }">{{ formatBirthday(item.birthday) }}</div>
              <div class="info-row" :class="{ invalid: isGenderIneligible(item) }">{{ formatGender(item.gender) }}</div>
            </template>
            <template v-else>
              <div class="info-name">{{ item.name || '-' }}</div>
              <div class="info-row">{{ item.mobile || '-' }}</div>
              <div class="info-row">{{ item.role || '-' }}</div>
            </template>
          </div>
          <!-- 勾选框独立点击，不触发外层 list-item 的点击事件 -->
          <van-checkbox
            :name="item.id"
            shape="square"
            @click.stop="toggleSelect(item)"
          />
        </div>
      </van-checkbox-group>
      <van-empty v-if="list.length === 0" :description="type === 'player' ? '暂无可添加的注册球员' : '暂无可添加的工作人员'" />
    </div>
    <div class="bottom-actions">
      <van-button
        class="confirm-btn"
        type="info"
        :disabled="selectedIds.length === 0"
        :style="{ 'background-color': jetlympic ? '#00A7FF' : 'var(--bg3)' }"
        @click="onConfirm"
      >
        确认添加
      </van-button>
    </div>
  </div>
</template>

<script>
import { Toast, Dialog, CheckboxGroup, Checkbox, Empty } from 'vant'
import { getBMMatchTeamSignup, getOrgTeamPlayers, getOrgTeamOfficers, checkBMMatchTeamPlayerSignup, createBMMatchTeamPlayersByPlayers, batchCreateBMMatchTeamOffice } from '@/api/match'
import { QNImageUtil, DateUtil } from '@/utils'
import Vue from 'vue'
Vue.use(CheckboxGroup).use(Checkbox).use(Dialog).use(Empty)
export default {
  name: 'MemberSelectList',
  data() {
    return {
      teamId: '',
      matchId: '',
      unionMatchId: '',
      type: 'player',
      regTeamId: '',
      list: [],
      selectedIds: [],
      jetlympic: false,
      /** 报名配置（仅 player 类型且已请求后存在）：性别限制、年龄限制等 */
      signupConfig: null
    }
  },
  computed: {
    pageTitle() {
      return this.type === 'player' ? '选择球员' : '选择工作人员'
    }
  },
  mounted() {
    if (window.localStorage.getItem('jetlympic')) this.jetlympic = true
    this.teamId = this.$route.query.teamId || ''
    this.matchId = this.$route.query.matchId || ''
    this.unionMatchId = this.$route.query.unionMatchId || ''
    this.regTeamId = this.$route.query.regTeamId || ''
    const t = (this.$route.query.type || 'player').toLowerCase()
    this.type = t === 'officer' ? 'officer' : 'player'
    document.title = this.pageTitle
    // if (!this.regTeamId) {
    //   Toast.fail('缺少注册球队信息')
    //   this.$router.back()
    //   return
    // }
    if (this.type === 'player') {
      this.fetchSignupConfig().then(() => this.loadSelectList())
    } else {
      this.fetchSignupConfig().then(() => this.loadSelectList())
    }
  },
  methods: {
    fetchSignupConfig() {
      const params = { matchId: this.matchId }
      if (this.teamId) params.teamId = this.teamId
      return getBMMatchTeamSignup(params).then(res => {
        if (!res || !res.data || !res.data.match) return
        const data = res.data
        const m = data.match
        const psfs = (m.playerSignupFields && m.playerSignupFields.split('|')) || []
        this.signupConfig = {
          genderLimit: m.genderLimit,
          minAge: m.minAge,
          maxAge: m.maxAge,
          isOpenAgeLimit: m.isOpenAgeLimit,
          playerSignupFields: psfs,
          /** 混合参赛时男女人数范围：maleMax/maleMin、femaleMax/femaleMin */
          maleMax: m.maleMax,
          maleMin: m.maleMin,
          femaleMax: m.femaleMax,
          femaleMin: m.femaleMin,
          /** 已加入球队的球员列表（含 gender） */
          existingPlayers: data.players || [],
          /** 工作人员职务配置（逗号分隔，仅职务在此列表内的才可批量添加） */
          teamOfficers: (m.teamOfficers && m.teamOfficers.split(',')) || [],
          /** 工作人员是否需要传证件信息：1=需要传 certType、IDCardNo，否则不传 */
          teamOfficersCertRequired: m.teamOfficersCertRequired,
          /** 已加入参赛球队的工作人员列表（用于过滤列表 + 人数校验） */
          existingOfficers: data.officers || [],
          /** 工作人员数量限制 */
          minOffice: m.minOffice,
          maxOffice: m.maxOffice
        }
      }).catch(() => {
        this.signupConfig = null
      })
    },
    /** 性别是否不符合报名条件（仅该字段标红） */
    isGenderIneligible(item) {
      if (this.type !== 'player' || !this.signupConfig) return false
      const c = this.signupConfig
      if (!c.playerSignupFields.includes('gender') || (c.genderLimit !== 1 && c.genderLimit !== 2)) return false
      return String(item.gender) !== String(c.genderLimit)
    },
    /** 年龄是否不符合报名条件（仅该字段标红） */
    isAgeIneligible(item) {
      if (this.type !== 'player' || !this.signupConfig) return false
      const c = this.signupConfig
      if (c.isOpenAgeLimit !== 1 || !c.minAge || !c.maxAge || !item.birthday) return false
      const birth = new Date(item.birthday).getTime()
      const min = new Date(c.minAge).getTime()
      const max = new Date(c.maxAge).getTime()
      return birth < max || birth > min
    },
    loadSelectList() {
      const fn = this.type === 'player' ? getOrgTeamPlayers : getOrgTeamOfficers
      fn(this.regTeamId).then(res => {
        if (!res || !res.data) return
        const data = res.data
        let rawList = data.list || data.players || data.officers || []
        if (this.type === 'officer' && this.signupConfig && (this.signupConfig.existingOfficers || []).length > 0) {
          const existingIds = new Set(
            (this.signupConfig.existingOfficers || []).map(o => o.regTeamOfficerId != null ? String(o.regTeamOfficerId) : String(o.id))
          )
          rawList = rawList.filter(item => {
            const id = item.regTeamOfficerId != null ? String(item.regTeamOfficerId) : String(item.id)
            return !existingIds.has(id)
          })
        }
        this.list = rawList
      }).catch(() => {
        this.list = []
      })
    },
    imageView(img) {
      return img ? QNImageUtil.imageView(img) : ''
    },
    formatBirthday(bmBirthday) {
      return bmBirthday ? DateUtil.parseDateTime(bmBirthday, '{y}-{m}-{d}') : '-'
    },
    formatGender(gender) {
      if (gender === '1') return '男'
      if (gender === '2') return '女'
      return '-'
    },
    async toggleSelect(item) {
      const id = item.id
      if (id == null || id === '') return
      const idx = this.selectedIds.indexOf(id)
      if (idx >= 0) {
        this.selectedIds = this.selectedIds.filter(x => x !== id)
        return
      }
      // 选中操作：需先校验，不通过则保持未选
      if (this.type === 'player') {
        const err = await this.validatePlayerSelection(item)
        if (err) {
          Dialog.alert({ title: '提示', message: err })
          return
        }
      } else if (this.type === 'officer') {
        const err = this.validateOfficerSelection(item)
        if (err) {
          Dialog.alert({ title: '提示', message: err })
          return
        }
      }
      this.selectedIds = [...this.selectedIds, id]
    },
    /** 工作人员选择时校验：人数不超过 maxOffice */
    validateOfficerSelection() {
      const c = this.signupConfig
      if (!c) return null
      const maxOffice = c.maxOffice != null ? Number(c.maxOffice) : null
      if (maxOffice == null) return null
      const existingCount = (c.existingOfficers || []).length
      const selectedCount = this.selectedIds.length
      if (existingCount + selectedCount + 1 > maxOffice) {
        return '工作人员人数已达上限'
      }
      return null
    },
    /** 选中前校验该球员是否可添加，返回错误文案或 null（通过） */
    async validatePlayerSelection(item) {
      // 1. 年龄/性别不符合（本地判断）
      if (this.isGenderIneligible(item) || this.isAgeIneligible(item)) {
        return '球员年龄/性别不符合报名条件'
      }
      const c = this.signupConfig
      // 2. 混合参赛时男/女人数上限（maleMax、femaleMax）：已有 + 当前已选 + 本项 不得超出
      if (c && (c.genderLimit === 0 || c.genderLimit === '0')) {
        const maleMax = c.maleMax != null ? Number(c.maleMax) : null
        const femaleMax = c.femaleMax != null ? Number(c.femaleMax) : null
        if (maleMax != null || femaleMax != null) {
          const existingMale = (c.existingPlayers || []).filter(p => String(p.gender) === '1').length
          const existingFemale = (c.existingPlayers || []).filter(p => String(p.gender) === '2').length
          const selectedItems = this.list.filter(i => this.selectedIds.includes(i.id))
          const selectedMale = selectedItems.filter(p => String(p.gender) === '1').length
          const selectedFemale = selectedItems.filter(p => String(p.gender) === '2').length
          const addMale = String(item.gender) === '1' ? 1 : 0
          const addFemale = String(item.gender) === '2' ? 1 : 0
          if (maleMax != null && existingMale + selectedMale + addMale > maleMax) {
            return '队伍男性队员人数已达上限'
          }
          if (femaleMax != null && existingFemale + selectedFemale + addFemale > femaleMax) {
            return '队伍女性队员人数已达上限'
          }
        }
      }
      // 3、4. 同时间段其他赛事、已加入其他球队 → 调接口（仅校验本球员）
      try {
        const res = await checkBMMatchTeamPlayerSignup({
          matchId: this.matchId,
          teamId: this.teamId,
          playerId: item.regPlayerId
        })
        // 接口成功 code=200，根据 data 布尔字段展示提示（文档：playerId 当 publicSignUp=2 即 regPlayerId）
        const data = (res && (res.data || (res.messages && res.messages.data))) || {}
        if (data.isSignupOtherUnionMatch) return '该球员同时间段已报名其他赛事'
        if (data.isSignupInOtherTeam) return '已加入其他球队'
        if (data.isSignup) return '该球员已报名'
      } catch (e) {
        const errData = e && (e.response && e.response.data || e.data)
        const msg = (errData && (errData.messages && errData.messages.error && errData.messages.error.message)) || (errData && (errData.message || errData.msg)) || (e && (e.message || e.msg)) || ''
        if (msg.includes('同时间段') || msg.includes('其他赛事')) return '该球员同时间段已报名其他赛事'
        if (msg.includes('其他球队') || msg.includes('已加入')) return '已加入其他球队'
        return msg || '检查失败'
      }
      return null
    },
    onConfirm() {
      if (this.selectedIds.length === 0) {
        Dialog.alert({ title: '提示', message: '请至少选择一项' })
        return
      }
      if (this.type === 'player') {
        this.doConfirmPlayers()
        return
      }
      if (this.type === 'officer') {
        this.doConfirmOfficers()
        return
      }
      this.$router.back()
    },
    /** 球员类型确认添加：选中项已在勾选时校验过，直接提交 */
    async doConfirmPlayers() {
      const selectedItems = this.list.filter(i => this.selectedIds.includes(i.id))
      const playerIds = selectedItems
        .map(i => i.regPlayerId)
        .filter(Boolean)

      if (playerIds.length !== selectedItems.length) {
        Dialog.alert({ title: '提示', message: '缺少球员标识，请刷新后重试' })
        return
      }

      try {
        await createBMMatchTeamPlayersByPlayers({
          matchId: this.matchId,
          teamId: this.teamId,
          playerIds: playerIds.join(',')
        })
        Toast.success('添加成功')
        this.$router.back()
      } catch (e) {
        const errData = e && (e.response && e.response.data || e.data)
        const msg = (errData && (errData.messages && errData.messages.error && errData.messages.error.message)) || (errData && (errData.message || errData.msg)) || (e && (e.message || e.msg)) || ''
        Dialog.alert({ title: '提示', message: msg || '添加失败' })
      }
    },
    /** 工作人员类型确认添加：按 match.teamOfficers 过滤后提交完整信息；teamOfficersCertRequired=1 时传 certType、IDCardNo */
    async doConfirmOfficers() {
      const selectedItems = this.list.filter(i => this.selectedIds.includes(i.id))
      const teamOfficers = (this.signupConfig && this.signupConfig.teamOfficers) || []
      const allowedRoles = teamOfficers.length ? teamOfficers : null
      const needCert = (this.signupConfig && this.signupConfig.teamOfficersCertRequired) === 1

      const officers = selectedItems
        .map(item => {
          if (allowedRoles != null && !allowedRoles.includes(item.role)) return null
          const base = {
            name: item.name,
            mobile: item.mobile,
            role: item.role,
            gender: item.gender,
            avatar: item.avatar,
            regTeamOfficerId: item.regTeamOfficerId || item.id
          }
          if (needCert) {
            base.certType = item.certType
            base.certNo = item.IDCardNo
          }
          return base
        })
        .filter(Boolean)

      if (officers.length === 0) {
        Dialog.alert({
          title: '提示',
          message: allowedRoles && allowedRoles.length
            ? '所选工作人员的职务不在当前赛事配置的职务范围内，无法添加'
            : '请至少选择一项'
        })
        return
      }

      try {
        await batchCreateBMMatchTeamOffice(
          { matchId: this.matchId, teamId: this.teamId },
          { officers: JSON.stringify(officers) }
        )
        Toast.success('添加成功')
        this.$router.back()
      } catch (e) {
        const errData = e && (e.response && e.response.data || e.data)
        const msg = (errData && (errData.messages && errData.messages.error && errData.messages.error.message)) || (errData && (errData.message || errData.msg)) || (e && (e.message || e.msg)) || ''
        Dialog.alert({ title: '提示', message: msg || '添加失败' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.member-select-list {
  min-height: 100vh;
  background: #f6f6f8;
  padding-bottom: 80px;
}
.title-info {
  padding: 16px;
  background: #fff;
  margin-bottom: 12px;
  .h1 {
    font-size: 18px;
    color: #1d2129;
    font-weight: 500;
  }
}
.list-section {
  padding: 0 12px;
}
.list-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #fff;
  border-radius: 8px;
  margin-bottom: 12px;
  .avatar {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    overflow: hidden;
    flex-shrink: 0;
    background: #e8e8e8;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .info {
    flex: 1;
    min-width: 0;
    margin-left: 12px;
    .info-name {
      font-size: 15px;
      font-weight: 500;
      color: #1d2129;
    }
    .info-row {
      font-size: 13px;
      font-weight: 500;
      color: #666666;
      margin-top: 4px;
      &.invalid {
        color: #BC2D2F;
      }
    }
  }
  .van-checkbox {
    flex-shrink: 0;
    margin-left: 12px;
  }
}
.bottom-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 16px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: flex-end;
  .confirm-btn {
    width: 132px;
    height: 50px;
    border: none;
    color: #fff;
    border-radius: 25px;
    &:disabled {
      opacity: 0.6;
    }
  }
}
</style>
